import React, { useEffect, useRef } from 'react';
import './Equalizer.css';

const Equalizer = ({ audioRef, analyser }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (audioRef.current && analyser) {
      const startDrawing = () => {
        const canvas = canvasRef.current;
        if (canvas) {
          const canvasCtx = canvas.getContext('2d');
          canvas.width = canvas.clientWidth;
          canvas.height = canvas.clientHeight;

          const bufferLength = analyser.frequencyBinCount;
          const dataArray = new Uint8Array(bufferLength);

          let hue = 240; // Начинаем с синего цвета (240 градусов по HSL)
          let hueDirection = 1; // Направление изменения цвета

          const draw = () => {
            requestAnimationFrame(draw);

            analyser.getByteFrequencyData(dataArray);

            // Убираем заливку фона
            canvasCtx.clearRect(0, 0, canvas.width, canvas.height);

            const barWidth = (canvas.width / bufferLength) * 2.5;
            let barHeight;
            let x;

            for (let i = 0; i < bufferLength; i++) {
              barHeight = dataArray[i] / 2;

              // Устанавливаем цвет с изменением hue
              hue = hue + hueDirection * 0.0003; // Очень медленное изменение hue

              // Плавный переход цвета обратно
              if (hue >= 270) {
                hueDirection = -1;
              } else if (hue <= 240) {
                hueDirection = 1;
              }

              canvasCtx.fillStyle = `hsl(${hue}, 100%, 50%)`;
              canvasCtx.beginPath();

              // Слева от центра
              x = canvas.width / 2 - (i + 1) * (barWidth + 1);
              canvasCtx.roundRect(x, (canvas.height / 2) - (barHeight / 2), barWidth, barHeight, 10);
              canvasCtx.fill();

              // Справа от центра
              x = canvas.width / 2 + i * (barWidth + 1);
              canvasCtx.roundRect(x, (canvas.height / 2) - (barHeight / 2), barWidth, barHeight, 10);
              canvasCtx.fill();
            }
          };

          draw();
        }
      };

      if (!audioRef.current.paused) {
        startDrawing();
      } else {
        audioRef.current.addEventListener('play', startDrawing);
      }

      audioRef.current.addEventListener('playing', () => {});
      audioRef.current.addEventListener('pause', () => {});
      audioRef.current.addEventListener('ended', () => {});
    }
  }, [audioRef, analyser]);

  return <canvas ref={canvasRef} className="equalizer"></canvas>;
};

export default Equalizer;